import { Building } from './building.model';
import { BuildingOpeningHour } from './building-opening-hour.model';
import { Meridian } from '../enums/meridian';

export class BuildingOpeningDay {
  building?: Building;
  day: number;
  id: number;
  isOpen: boolean;
  openingHours: BuildingOpeningHour[] | string[];

  constructor(values= {}) {
    Object.assign(this, values);
  }

  public getHoursByMeridian(meridian: Meridian): BuildingOpeningHour {
    for (const hours of this.openingHours as BuildingOpeningHour[]) {
      if (hours.period.toLowerCase() === meridian.toLowerCase()) {
        return hours;
      }
    }

    return this.openingHours[0] as BuildingOpeningHour;
  }
}
